import { FieldValidationErrorCodes, MaxFileNameSizeInBytes, fiveMegabyte }
  from '../Constants';
import Utils from '../Utils';

const valid = { errors: {}, isValid: true };

export default {
  validate(file) {
    const documentErrors = [];
    if (!Utils.hasPdfExtension(file.name)) {
      documentErrors.push(FieldValidationErrorCodes.invalidFileFormat);
    }

    if (file.size > fiveMegabyte) {
      documentErrors.push(FieldValidationErrorCodes.invalidFileSize);
    }

    if (Utils.getUtf8ByteCount(file.name) > MaxFileNameSizeInBytes) {
      documentErrors.push(FieldValidationErrorCodes.invalidFileNameSizeInBytes);
    }

    if (documentErrors.length !== 0) {
      return { errors: { document: documentErrors }, isValid: false };
    }

    return valid;
  }
};
